// extracted by mini-css-extract-plugin
export default {"nextAvailable":"clinicNextAvailable_nextAvailable__srBCb"};